import queryString from 'qs'
import request from '../../../../shared/request'

export function getJobList(filters) {
  const qs = queryString.stringify(filters)
  return request(`/reports/general/schedule-report/job-list?${qs}`)
}

export function getFullReport(filters) {
  const qs = queryString.stringify(filters)

  return request(`/reports/general/schedule-report/full-report?${qs}`)
}



// WEBPACK FOOTER //
// ./src/redux/api/reports/general/scheduleReport.js